/**
 * Whether this BUILD offers "Public" as a choosable artifact visibility.
 *
 * Owner, 2026-09-24: 幫我把 artifact 可以放置為 Public 的這一個按鈕的功能先鎖起來, 之後我們
 * 會需要加到 Premium Feature 裡面或者是 Pro Feature 裡面. On the shape: 我們只需要在
 * environment variable 裡面做一個更換 之後就直接可以上架來開啟或關閉這樣子的功能… 這樣我們
 * 所有的代碼在 dev 跟 product 裡面都是同步的. And on what the person should see meanwhile:
 * 目前上面要顯示這個按鈕, 但只是這個按鈕是被 disable 的, 讓使用者可以意識到以後有這種功能的存在.
 *
 * So the row is never removed from the dial — only its pressability moves with this
 * flag. Turning the feature on is one variable in the build, not a patch, and the same
 * source ships to dev and prod.
 *
 * OFF UNLESS THE BUILD SAYS `on`, which is the OPPOSITE polarity to billing/flags.ts
 * next door, and the difference is deliberate rather than an oversight. There, the
 * costly mistake was a prod build that forgot a variable and hid the only way to buy.
 * Here it is the mirror image: a build that forgot a variable and gave away the thing
 * we intend to charge for. Absence means locked, the same rule the push preferences
 * use, so a bundle that has never heard of this is safe.
 *
 * THIS IS THE LEAST LOAD-BEARING OF THE THREE COPIES, and that is worth knowing before
 * anyone treats it as the gate. Its twins are the edge's AVENGENTS_PUBLIC_ARTIFACTS
 * (which refuses to write or republish `public`) and the relay's ART_PUBLIC_ARTIFACTS
 * (which decides whether a stranger is admitted, and is the one that actually enforces
 * because it is the only one running on our hardware). This copy exists so the App does
 * not offer a control the machine behind it would refuse.
 *
 * Read at call time, not at module load, so a test can flip it with vi.stubEnv — the
 * same reason billingUiOn does.
 */
export function publicArtifactsOn(): boolean {
  const env = import.meta.env as Record<string, string | undefined>
  return env['VITE_PUBLIC_ARTIFACTS'] === 'on'
}
